import { AxiosRestApplicationClient as GeoDataRestApplicationClient } from '@g2-shared/api-client/generated/geo-data-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const GeoDataApiClient = new GeoDataRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  GeoDataApiClient: GeoDataRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  NotificationService: NotificationsService,
  GeoDataApiClient,
});
